const dadosFixacao = (vestigio) => ({
  id: `FIXACAO_${vestigio.id}`,
  operacao: 'Fixado',
  usuario: vestigio.usuFix
    ? `${vestigio.usuFix.nome.toLowerCase() === 'outro' ? vestigio.fixacaoInput || 'NÃO INFORMADO' : `${vestigio.usuFix.nome} - CPF: ${vestigio.usuFix.cpf}`}`
    : ' - ',
  setor: ' - ',
  lacre: ' - ',
  numeracao: ' - ',
  data: new Date(vestigio.dataFixacao),
})

const dadosColeta = (vestigio) => ({
  id: `COLETA_${vestigio.id}`,
  operacao: 'Coletado',
  usuario: vestigio.usuCol
    ? `${vestigio.usuCol.nome.toLowerCase() === 'outro' ? vestigio.coletaInput || 'NÃO INFORMADO' : `${vestigio.usuCol.nome} - CPF: ${vestigio.usuCol.cpf}`}`
    : ' - ',
  setor: ' - ',
  lacre: ' - ',
  numeracao: ' - ',
  data: new Date(vestigio.dataColeta),
})

const dadosAcondicionamento = (vestigio) => ({
  id: `ACONDICIONAMENTO_${vestigio.id}`,
  operacao: 'Acondicionado',
  usuario: vestigio.usuAcond
    ? `${vestigio.usuAcond.nome.toLowerCase() === 'outro' ? vestigio.acondicionamentoInput || 'NÃO INFORMADO' : `${vestigio.usuAcond.nome} - CPF: ${vestigio.usuAcond.cpf}`}`
    : ' - ',
  setor: ' - ',
  lacre: vestigio.lacreAcondicionamento || ' - ',
  numeracao: ' - ',
  data: new Date(vestigio.dataAcondicionamento),
})

const dadosTransporte = (vestigio) => ({
  id: `TRANSPORTE_${vestigio.id}`,
  operacao: 'Transportado',
  usuario: vestigio.usuTrans
    ? `${vestigio.usuTrans.nome.toLowerCase() === 'outro' ? vestigio.transporteInput || 'NÃO INFORMADO' : `${vestigio.usuTrans.nome} - CPF: ${vestigio.usuTrans.cpf}`}`
    : ' - ',
  setor: ' - ',
  lacre: vestigio.lacreAcondicionamento || ' - ',
  numeracao: ' - ',
  data: new Date(vestigio.dataTransporte),
})

const dadosRecebimento = (vestigio) => ({
  id: `RECEBIMENTO_${vestigio.id}`,
  operacao: 'Recebido no setor',
  usuario: vestigio.usuRec ? `${vestigio.usuRec.nome} - CPF: ${vestigio.usuRec.cpf}` : ' - ',
  setor: vestigio.setRec ? `${vestigio.setRec.nome}` : ' - ',
  lacre: vestigio.lacreAcondicionamento || ' - ',
  numeracao: vestigio.identificador || ' - ',
  data: new Date(vestigio.dataTransporte),
})

const getStatusEncaminhamento = (encaminhamento) => {
  if (encaminhamento.status) {
    switch (encaminhamento.status) {
      case 'ENCAMINHADO':
        return `Encaminhamento realizado. Destino: ${encaminhamento.setDest ? encaminhamento.setDest.nome : ''}`
      case 'ACEITO':
        return 'Encaminhamento aceito'
      case 'NEGADO':
        return 'Encaminhamento negado'
      case 'CANCELADO':
        return 'Encaminhamento cancelado'
      default:
        return ' - '
    }
  }
  return ' - '
}

const getStatusPassagemCustodia = (passagemCustodia) => {
  if (passagemCustodia.status) {
    switch (passagemCustodia.status) {
      case 'SOLICITADO':
        return `Passagem de custódia solicitada. Usuário destino: ${passagemCustodia.usuDest ? `${passagemCustodia.usuDest.nome} - CPF: ${passagemCustodia.usuDest.cpf}` : ''}`
      case 'ACEITO':
        return 'Passagem de custódia aceita'
      case 'NEGADO':
        return 'Passagem de custódia negada'
      case 'CANCELADO':
        return 'Passagem de custódia cancelada'
      default:
        return ' - '
    }
  }
  return ''
}

const getSetorEncaminhamento = (encaminhamento) => {
  if (encaminhamento.status) {
    if (encaminhamento.status === 'NEGADO' || encaminhamento.status === 'ACEITO') {
      return encaminhamento.setDest ? encaminhamento.setDest.nome : ' - '
    }
    return encaminhamento.setOrig ? encaminhamento.setOrig.nome : ' - '
  }
  return '-'
}

const dadosUsuarioEncaminhamento = (encaminhamento) => {
  if (encaminhamento.status === 'ACEITO' || encaminhamento.status === 'NEGADO') {
    if (!encaminhamento.usuDest) return '-'
    return `${encaminhamento.usuDest.nome} - CPF: ${encaminhamento.usuDest.cpf}`
  }
  if (!encaminhamento.usuOrig) return '-'
  return `${encaminhamento.usuOrig.nome} - CPF: ${encaminhamento.usuOrig.cpf}`
}

const dadosUsuarioPassagemCustodia = (passagemCustodia) => {
  if (passagemCustodia.status === 'ACEITO' || passagemCustodia.status === 'NEGADO') {
    if (!passagemCustodia.usuDest) return '-'
    return `${passagemCustodia.usuDest.nome} - CPF: ${passagemCustodia.usuDest.cpf}`
  }
  if (!passagemCustodia.usuOrig) return '-'
  return `${passagemCustodia.usuOrig.nome} - CPF: ${passagemCustodia.usuOrig.cpf}`
}

const dadosEncaminhamento = (encaminhamento) => ({
  id: `ENCAMINHAMENTO_${encaminhamento.id}_${encaminhamento.createdAt}`,
  operacao: getStatusEncaminhamento(encaminhamento),
  usuario: dadosUsuarioEncaminhamento(encaminhamento),
  setor: getSetorEncaminhamento(encaminhamento),
  lacre: encaminhamento.lacre || ' - ',
  numeracao: encaminhamento.identificador || ' - ',
  data: new Date(encaminhamento.createdAt),
})

const dadosPassagemCustodia = (passagemCustodia) => ({
  id: `PASSAGEM_${passagemCustodia.id}_${passagemCustodia.createdAt}`,
  operacao: getStatusPassagemCustodia(passagemCustodia),
  usuario: dadosUsuarioPassagemCustodia(passagemCustodia),
  setor: passagemCustodia.set ? passagemCustodia.set.nome : '',
  lacre: passagemCustodia.lacre || ' - ',
  numeracao: passagemCustodia.identificador || ' - ',
  data: new Date(passagemCustodia.createdAt),
})

const dadosEntrega = (entrega) => ({
  id: `ENTREGA_${entrega.id}`,
  operacao: `Entregue. Setor destino: ${entrega.setDest ? entrega.setDest.nome : ' - '}. Usuário recebedor: ${entrega.usuRec ? `${entrega.usuRec.nome} - CPF: ${entrega.usuRec.cpf}` : ' - '}`,
  usuario: entrega.usu ? `${entrega.usu.nome} - CPF: ${entrega.usu.cpf}` : ' - ',
  setor: entrega.setor ? entrega.setor.nome : ' - ',
  lacre: entrega.lacre || ' - ',
  numeracao: entrega.identificador || ' - ',
  data: new Date(entrega.createdAt),
})

const dadosRetorno = (retorno) => ({
  id: `RETORNO_${retorno.id}`,
  operacao: `Retornou. Setor origem: ${retorno?.setOrig ? retorno.setOrig.nome : ' - '}. Usuario responsável pela entrega: ${retorno?.usuOrig ? `${retorno.usuOrig.nome} - CPF: ${retorno.usuOrig.cpf}` : ' - '}. Setor destino: ${retorno?.setDest ? retorno.setDest.nome : ' - '}. `,
  usuario: retorno?.usuDest ? `${retorno.usuDest.nome} - CPF: ${retorno.usuDest.cpf}` : ' - ',
  setor: retorno.setOrig ? retorno.setOrig.nome : ' - ',
  lacre: retorno.lacre || ' - ',
  numeracao: retorno?.identificador || ' - ',
  data: retorno ? new Date(retorno.createdAt) : '',
})

const dadosRetirada = (retirada) => ({
  id: `RETIRADA_${retirada.id}_${retirada.createdAt}`,
  operacao: 'Retirado',
  usuario: retirada.recep ? `${retirada.recep.nome} - CPF: ${retirada.recep.cpf}` : ' - ',
  setor: retirada.setor ? retirada.setor.nome : ' - ',
  lacre: retirada.lacre || ' - ',
  numeracao: retirada.identificador || ' - ',
  data: new Date(retirada.createdAt),
})

const dadosInformacaoAdicionada = (informacao) => ({
  id: `INFO_${informacao.id}_${informacao.createdAt}`,
  operacao: 'Informação adicionada',
  usuario: informacao.usu ? `${informacao.usu.nome} - CPF: ${informacao.usu.cpf}` : '',
  setor: informacao.setor ? informacao.setor.nome : '',
  lacre: informacao.lacre || ' - ',
  numeracao: informacao.identificador || ' - ',
  data: new Date(informacao.createdAt),
})

const dadosVestigioConsumido = (consumo) => ({
  id: `CONSUMO_${consumo.id}_${consumo.createdAt}`,
  operacao: 'Vestígio consumido',
  usuario: consumo.usuario ? `${consumo.usuario.nome} - CPF: ${consumo.usuario.cpf}` : '',
  setor: consumo.setor ? consumo.setor.nome : '',
  lacre: consumo.lacre || ' - ',
  numeracao: consumo.identificador || ' - ',
  data: new Date(consumo.createdAt),
})

const dadosOperacaoGuardar = (operacaoGuardar) => ({
  id: `GUARDAR_${operacaoGuardar.id}_${operacaoGuardar.createdAt}`,
  operacao: `Guardado. Local: ${operacaoGuardar.localizacao ? operacaoGuardar.localizacao : ' - '}`,
  usuario: operacaoGuardar.usu ? `${operacaoGuardar.usu.nome} - CPF: ${operacaoGuardar.usu.cpf}` : ' - ',
  setor: operacaoGuardar.setor ? operacaoGuardar.setor.nome : ' - ',
  lacre: operacaoGuardar.lacre || ' - ',
  numeracao: operacaoGuardar.identificador || ' - ',
  data: new Date(operacaoGuardar.createdAt),
})

const dadosClassificacao = (classificacao) => ({
  id: `CLASSIFICACAO_${classificacao.id}_${classificacao.createdAt}`,
  operacao: 'Classificado',
  usuario: classificacao.usu ? `${classificacao.usu.nome} - CPF: ${classificacao.usu.cpf}` : ' - ',
  setor: classificacao.setor ? classificacao.setor.nome : ' - ',
  lacre: classificacao.lacre || ' - ',
  numeracao: classificacao.identificador || ' - ',
  data: new Date(classificacao.createdAt),
})

const dadosDesmembramento = (desmembramento) => ({
  id: `DESMEMBRAMENTO_${desmembramento.id}_${desmembramento.createdAt}`,
  operacao: 'Desmembrado',
  usuario: desmembramento.usu ? `${desmembramento.usu.nome} - CPF: ${desmembramento.usu.cpf}` : ' - ',
  setor: desmembramento.setor ? desmembramento.setor.nome : ' - ',
  lacre: desmembramento.lacre || ' - ',
  numeracao: desmembramento.novosIdentificadores
    ? desmembramento.novosIdentificadores.map((ident, index) => `${ident}${index < desmembramento.novosIdentificadores.length - 1 ? ', ' : ''}`).join('')
    : '',
  data: new Date(desmembramento.createdAt),
})

const dadosCriacaoPorDesmembramento = (criacaoPorDesmembramento) => ({
  id: `CRI_DESM_${criacaoPorDesmembramento.id}_${criacaoPorDesmembramento.createdAt}`,
  operacao: 'Separado em desmembramento',
  usuario: criacaoPorDesmembramento.usu ? `${criacaoPorDesmembramento.usu.nome} - CPF: ${criacaoPorDesmembramento.usu.cpf}` : ' - ',
  setor: criacaoPorDesmembramento.setor ? criacaoPorDesmembramento.setor.nome : ' - ',
  lacre: criacaoPorDesmembramento.lacre || ' - ',
  numeracao: criacaoPorDesmembramento.identificador || ' - ',
  data: new Date(criacaoPorDesmembramento.createdAt),
})

const dadosCriacaoPorExtracao = (criacaoPorExtracao) => ({
  id: `CRI_EXTR_${criacaoPorExtracao.id}_${criacaoPorExtracao.createdAt}`,
  operacao: 'Extraído em exame',
  usuario: criacaoPorExtracao.usu ? `${criacaoPorExtracao.usu.nome} - CPF: ${criacaoPorExtracao.usu.cpf}` : ' - ',
  setor: criacaoPorExtracao.setor ? criacaoPorExtracao.setor.nome : ' - ',
  lacre: criacaoPorExtracao.lacre || ' - ',
  numeracao: criacaoPorExtracao.identificador || ' - ',
  data: new Date(criacaoPorExtracao.createdAt),
})

const dadosDescarte = (vestigio) => ({
  id: `DESCARTE_${vestigio.id}_${vestigio.dataDescarte}`,
  operacao: 'Descartado',
  usuario: vestigio.usuDesc ? `${vestigio.usuDesc.nome} - CPF: ${vestigio.usuDesc.cpf}` : ' - ',
  setor: vestigio.setorDesc?.nome || 'Não Informado',
  lacre: vestigio.lacre || ' - ',
  numeracao: vestigio.identificador || ' - ',
  data: new Date(vestigio.dataDescarte),
})

const dadosAcao = (acao) => {
  switch (acao.tipo) {
    case 'ENCAMINHAMENTO':
      return acao.encamin ? dadosEncaminhamento(acao.encamin) : {}

    case 'RETIRADA':
      return acao.retir ? dadosRetirada(acao.retir) : {}

    case 'GUARDAMENTO':
      return acao.guard ? dadosOperacaoGuardar(acao.guard) : {}

    case 'CRIACAO_POR_DESMEMBRAMENTO':
      return acao.criDesm ? dadosCriacaoPorDesmembramento(acao.criDesm) : {}

    case 'CRIACAO_POR_EXTRACAO':
      return acao.criExt ? dadosCriacaoPorExtracao(acao.criExt) : {}

    case 'PASSAGEM_CUSTODIA':
      return acao.passagem ? dadosPassagemCustodia(acao.passagem) : {}

    case 'ENTREGA':
      return acao.entrega ? dadosEntrega(acao.entrega) : {}

    case 'INFORMACAO_ADICIONADA':
      return acao.infAddVest ? dadosInformacaoAdicionada(acao.infAddVest) : {}

    case 'CONSUMO_VESTIGIO':
      return acao.consVest ? dadosVestigioConsumido(acao.consVest) : {}

    case 'RETORNO':
      return acao.retornoVest ? dadosRetorno(acao.retornoVest) : {}

    case 'CLASSIFICACAO':
      return acao.classif ? dadosClassificacao(acao.classif) : {}

    case 'DESMEMBRAMENTO':
      return acao.desmemb ? dadosDesmembramento(acao.desmemb) : {}

    default:
      return {}
  }
}

export const popularAcoes = (vestigio) => {
  let acoes = []
  if (!vestigio) return acoes

  if (vestigio.vesAnts && vestigio.vesAnts.length) {
    vestigio.vesAnts.forEach((vest) => {
      acoes = acoes.concat(popularAcoes(vest))
    })
  }

  if (vestigio.id_usuario_transporte) {
    acoes.push(dadosFixacao(vestigio))
    acoes.push(dadosColeta(vestigio))
    acoes.push(dadosAcondicionamento(vestigio))
    acoes.push(dadosTransporte(vestigio))
  }

  if (vestigio.id_usuario_recebimento) {
    acoes.push(dadosRecebimento(vestigio))
  }

  if (vestigio.acoes) {
    vestigio.acoes.forEach((acao) => {
      const formatted = dadosAcao(acao)
      if (formatted && formatted.id) {
        acoes.push(formatted)
      }
    })
  }

  if (vestigio.id_usuario_descarte) {
    acoes.push(dadosDescarte(vestigio))
  }

  return acoes
}
